module.exports = __webpack_public_path__ + "static/media/decentralize_1.4a10a7a7.svg";